export default class Request {
  constructor(cacheName = 'app-cache') {
    this.cacheName = cacheName;
  }

  /**
   * Método base con estrategia stale-while-revalidate
   * @param {string} cacheKey - Clave única para Cache API
   * @param {Function} fetchFn - Función que retorna Promesa con { success, payload }
   * @param {Function} onData - Callback para aplicar la respuesta
   */
  async fetchWithCache(cacheKey, fetchFn, onData, options = {}) {
    const { skipNetworkOnError = false } = options;

    if (!cacheKey || typeof fetchFn !== 'function' || typeof onData !== 'function') {
      console.warn("fetchWithCache: parámetros inválidos");
      return { success: false };
    }

    try {
      let cache = null;
      
      if (typeof caches?.open === 'function') {
        cache = await caches.open(this.cacheName);
  
        // 1. Leer desde cache
        const cachedResponse = await cache.match(cacheKey);
        if (cachedResponse) {
          const cachedData = await cachedResponse.json();
          if (cachedData && cachedData?.success) {
            onData(cachedData, 'CACHE');
          }
        }
      }

      // 2. Revalidar desde red
      const response = await fetchFn();
      if (response && response?.success) {
        const newResponse = new Response(JSON.stringify(response), {
          headers: { 'Content-Type': 'application/json' }
        });

        if (cache) {
          await cache.put(cacheKey, newResponse);
        }

        onData(response, 'REQUEST');
      }

      return { success: true };
    } catch (err) {
      console.warn("Request.fetchWithCache: error general", err);
      return { success: !skipNetworkOnError };
    }
  }
}
